import { Create, SimpleForm, TextInput } from "react-admin";
import { useLocation } from "react-router-dom";

export const GroupCreate = (props: any) => {
  const location = useLocation();

  // 从 URL 中获取 parentId
  const searchParams = new URLSearchParams(location.search);
  const parentId = searchParams.get("parentId");

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" label="部门名称" />
        {parentId && <TextInput source="parentId" defaultValue={parentId} style={{ display: 'none' }} />}
      </SimpleForm>
    </Create>
  );
};